// extracted by mini-css-extract-plugin
export var compactFilters = "_eb-4";
export var detailImage = "_eb-1";
export var dropdownContainer = "_eb-2";
export var imageContainer = "_eb-0";
export var selectedCard = "_eb-3";